import Swal from "sweetalert2";

export const handleDeleteItem = (index, dataList, setDataList, errors, setErrors, setFormValid) => {
    return new Promise((resolve) => {
        Swal.fire({
            title: 'Are you sure?',
            text: 'Do you really want to delete this item?',
            icon: 'warning',
            showCancelButton: true,
            confirmButtonText: 'Yes, delete it!',
            cancelButtonText: 'No, cancel!',
        }).then((result) => {
            if (result.isConfirmed) {
                const updatedList = dataList?.filter((_, i) => i !== index);
                setDataList(updatedList);

                // Remove errors for the deleted entry
                const newErrors = { ...errors };
                delete newErrors[index];

                // Re-index errors
                const reindexedErrors = {};
                Object.keys(newErrors).forEach((key) => {
                    const newKey = parseInt(key) > index ? parseInt(key) - 1 : parseInt(key);
                    reindexedErrors[newKey] = newErrors[key];
                });

                setErrors(reindexedErrors);
                setFormValid(reindexedErrors);
                resolve({ updatedList, reindexedErrors });
            } else {
                resolve(null);
            }
        });
    });
};
